import { Aggregation, Pagination, QueryParams } from '~/composables';
import { convertAttHeightOptionsValueToLabel } from '~/modules/catalog/category/helpers/filters';

export const getCategoryMetaTitleSuffix = (query: QueryParams, filters: Aggregation[], pagination: Pagination | undefined): string => {
  const queryParams = [];
  const attributeNameMap = {
    'att_by_type': 'Type',
    'att_climbing_options': 'Climbing Style',
    'color': 'Color',
    'att_fabric': 'Fabric',
    'att_by_material': 'Material',
    'size_swatch': 'Size',
    'manufacturer': 'Made In',
    'att_headboard_height': 'Headboard Height',
    'att_by_design': 'Design',
    'b_collection_name': 'Collection',
    'price': 'Price',
    'att_height_options': 'Height'
  };

  for (const [attribute, queryValue] of Object.entries(query)) {
    if (!attributeNameMap.hasOwnProperty(attribute)) {
      continue;
    }

    const attributeValues = Array.isArray(queryValue) ? queryValue : [queryValue];
    for (const attributeValue of attributeValues) {
      if (attribute === 'price') {
        queryParams.push(`${attributeNameMap[attribute]} ${attributeValue.replace('_', '-')}`);
        continue;
      }
      if (attribute !== 'size_swatch' && attribute !== 'att_height_options') {
        queryParams.push(`${attributeNameMap[attribute]} ${attributeValue}`);
        continue;
      }

      if (attribute === 'att_height_options') {
        const label = convertAttHeightOptionsValueToLabel(attributeValue, filters);
        if (!label) {
          continue;
        }
        queryParams.push(`${attributeNameMap[attribute]} ${label}`);
        continue;
      }

      const attributeValueParts = attributeValue.toLowerCase().split('xl');
      if (attributeValueParts.length === 2) {
        queryParams.push(`${attributeNameMap[attribute]} ${attributeValueParts[0].trim()} XL/${attributeValueParts[1].trim()}`);
      } else if (attributeValueParts.length === 3) {
        queryParams.push(`${attributeNameMap[attribute]} ${attributeValueParts[0].trim()} XL/${attributeValueParts[1].trim()} XL`);
      } else {
        queryParams.push(`${attributeNameMap[attribute]} ${attributeValueParts[0].trim()}`);
      }
    }
  }

  let suffix = '';
  if (queryParams.length === 2) {
    suffix += ` — ${queryParams[0].toLowerCase()} and ${queryParams[1].toLowerCase()}`;
  } else if (queryParams.length > 2) {
    suffix += ` — ${queryParams.map(param => param.toLowerCase()).join(', ')}`;
  } else if (queryParams.length > 0) {
    suffix += ` — ${queryParams.map(param => param.toLowerCase()).join(', ')}`;
  }

  const page = pagination ? pagination.currentPage : parseInt(query.page);
  if (page > 1) {
    suffix += ` (Page ${page})`;
  }

  return suffix;
}
